// extracted by mini-css-extract-plugin
export default {"content":"HistoryModal_content__a8WT1","title":"HistoryModal_title__uTSh4"};